import { Outlet } from "react-router";
import { useEffect, useState } from "react";
import LimitedExperienceModal from "components/modals/admin/limited_experience";

const AdminLayout = (): JSX.Element => {
  const [openLimitedExperienceModal, setOpenLimitedExperienceModal] =
    useState<boolean>(false);

  const lg = window.innerWidth > 768;

  useEffect(() => {
    if (!lg && !openLimitedExperienceModal) {
      setOpenLimitedExperienceModal(true);
    }
  }, [lg]);

  return (
    <>
      <Outlet />

      <LimitedExperienceModal
        isOpen={openLimitedExperienceModal}
        onClose={() => setOpenLimitedExperienceModal(false)}
      />
    </>
  );
};

export default AdminLayout;
